import { Icon, IconProps } from '@chakra-ui/react';

export function TaskSuccessIcon(props: IconProps): JSX.Element {
  return (
    <Icon
      width="43"
      height="42"
      viewBox="0 0 43 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.5 41.6944C18.6373 41.6944 15.947 41.1512 13.4292 40.0647C10.9114 38.9783 8.72126 37.5038 6.85877 35.6413C4.99627 33.7788 3.5218 31.5887 2.43535 29.0708C1.34889 26.553 0.805664 23.8628 0.805664 21C0.805664 18.1373 1.34889 15.447 2.43535 12.9292C3.5218 10.4114 4.99627 8.22126 6.85877 6.35877C8.72126 4.49627 10.9114 3.0218 13.4292 1.93535C15.947 0.848891 18.6373 0.305664 21.5 0.305664C23.7419 0.305664 25.8631 0.633325 27.8636 1.28865C29.864 1.94397 31.7093 2.85797 33.3993 4.03065L30.3986 7.08307C29.088 6.2553 27.6911 5.6086 26.208 5.14297C24.7249 4.67735 23.1556 4.44454 21.5 4.44454C16.9128 4.44454 13.0067 6.05698 9.78185 9.28185C6.55698 12.5067 4.94454 16.4128 4.94454 21C4.94454 25.5873 6.55698 29.4934 9.78185 32.7182C13.0067 35.9431 16.9128 37.5555 21.5 37.5555C26.0873 37.5555 29.9934 35.9431 33.2182 32.7182C36.4431 29.4934 38.0555 25.5873 38.0555 21C38.0555 20.3792 38.021 19.7584 37.9521 19.1375C37.8831 18.5167 37.7796 17.9131 37.6417 17.3268L41.0045 13.964C41.3839 15.0677 41.6771 16.2058 41.884 17.3785C42.0909 18.5512 42.1944 19.7584 42.1944 21C42.1944 23.8628 41.6512 26.553 40.5647 29.0708C39.4783 31.5887 38.0038 33.7788 36.1413 35.6413C34.2788 37.5038 32.0887 38.9783 29.5708 40.0647C27.053 41.1512 24.3628 41.6944 21.5 41.6944ZM18.6028 30.5195L9.80772 21.7243L12.7049 18.8271L18.6028 24.725L39.2972 3.97892L42.1944 6.87613L18.6028 30.5195Z"
        fill="url(#paint0_linear_685_609)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_685_609"
          x1="-6.88944"
          y1="21.8461"
          x2="4.60074"
          y2="-6.91217"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#844AE3" />
          <stop offset="1" stop-color="#E14AE3" />
        </linearGradient>
      </defs>
    </Icon>
  );
}
